// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"7256c570","239":"807d605c","732":"6c22405a","977":"f96a1f56"}[chunkId] + ".chunk.js";
};